import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TurnstileComponent } from './turnstile.component';

@NgModule({
  declarations: [TurnstileComponent],
  imports: [CommonModule],
  exports: [TurnstileComponent],
})
export class TurnstileModule {}
